import React from 'react'
import PropTypes from 'prop-types'

import { useGetMutateCall } from '../../lib/api/get'

export const Activities = ({ isLocalEnvironment, setOpenActivity, childFormData }) => {
  const getCallMutation = useGetMutateCall()
  const [downloadingId, setDownloadingId] = React.useState(null)
  const [enableView, setEnableView] = React.useState(false)
  const [viewData, setViewData] = React.useState(null)

  React.useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setOpenActivity(false)
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  const getDoc = async (id) => {
    setDownloadingId(id)
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'activityDetail',
        id: id,
        params: '',
        isDynamic: true,
      })
      .then((resp) => {
        const link = document.createElement('a')
        link.setAttribute('href', resp.formData?.fileURL)
        link.setAttribute('target', '_blank')

        document.body.appendChild(link)

        link.click()
      })
  }

  const openView = (data) => {
    setEnableView(true)
    setViewData(data)
  }

  const closeView = () => {
    setEnableView(false)
    setViewData(null)
  }

  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Activity Details
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setOpenActivity(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-card">
              <div className="trtui-card-body">
                {enableView ? (
                  <div className="trtui-row trtui-g-2">
                    <div className={`trtui-col-md-6 trtui-has-validation`}>
                      <label className="trtui-form-control-label">Type</label>
                      <div className="trtui-input-group trtui-has-validation">
                        <input
                          type="text"
                          className={`trtui-form-control`}
                          style={{
                            color: '#000000',
                            paddingRight: 'calc(1.5em + 1rem)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                            backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                          }}
                          defaultValue={viewData.activityDetailType}
                        />
                      </div>
                    </div>
                    <div className={`trtui-col-md-6 trtui-has-validation`}>
                      <label className="trtui-form-control-label">Label</label>
                      <div className="trtui-input-group trtui-has-validation">
                        <input
                          type="text"
                          className={`trtui-form-control`}
                          style={{
                            color: '#000000',
                            paddingRight: 'calc(1.5em + 1rem)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                            backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                          }}
                          defaultValue={viewData.activityDetailLabel}
                        />
                      </div>
                    </div>
                    <div className={`trtui-col-md-6 trtui-has-validation`}>
                      <label className="trtui-form-control-label">Description</label>
                      <div className="trtui-input-group trtui-has-validation">
                        <textarea
                          type="text"
                          className={`trtui-form-control`}
                          style={{
                            paddingRight: 'calc(1.5em + 1rem)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                            backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                          }}
                        >
                          {viewData.activityDetailDescription}
                        </textarea>
                      </div>
                    </div>
                    <div className={`trtui-col-md-6 trtui-has-validation`}>
                      <label className="trtui-form-control-label">Notes</label>
                      <div className="trtui-input-group trtui-has-validation">
                        <textarea
                          type="text"
                          className={`trtui-form-control`}
                          style={{
                            paddingRight: 'calc(1.5em + 1rem)',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                            backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                          }}
                        >
                          {viewData.activityDetailNotes}
                        </textarea>
                      </div>
                    </div>
                    <div className="trtui-col-md-12">
                      <button
                        className={`trtui-btn trtui-btn-primary`}
                        onClick={() => closeView()}
                        type="button"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="trtui-tab-content">
                    <div className={`trtui-tab-pane trtui-active`} role="tabpanel">
                      <div className="trtui-table-responsive trtui-mt-xl-0">
                        <table className="trtui-table trtui-table-white trtui-table-striped trtui-table-nowrap trtui-align-middle trtui-mb-0">
                          <thead>
                            <tr>
                              <th scope="col">Type</th>
                              <th scope="col">Label</th>
                              <th scope="col">Description</th>
                              <th scope="col">Notes</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {childFormData.activityDetails.length > 0 &&
                              childFormData.activityDetails
                                .sort(
                                  (a, b) =>
                                    a.activityDetailSortOrderNumber -
                                    b.activityDetailSortOrderNumber,
                                )
                                .map((c, cInd) =>
                                  c.activityDetailType === 'image' ? (
                                    <tr key={cInd}>
                                      <td colSpan={4}>{c['activityDetailLabel']}</td>
                                      <td>
                                        <div className="trtui-hstack trtui-gap-3 trtui-flex-wrap">
                                          <span
                                            className="trtui-link-primary trtui-fs-15 trtui-cursor-pointer"
                                            onClick={() => getDoc(c.activityDetailId)}
                                            disabled={
                                              getCallMutation.isLoading &&
                                              downloadingId === c.activityDetailId
                                            }
                                          >
                                            {getCallMutation.isLoading &&
                                            downloadingId === c.activityDetailId ? (
                                              <span
                                                className="trtui-spinner-border trtui-spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            ) : (
                                              <i className="ri-download-2-line" />
                                            )}
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr key={cInd}>
                                      <td>{c['activityDetailType']}</td>
                                      <td>{c['activityDetailLabel']}</td>
                                      <td>{c['activityDetailDescription']}</td>
                                      <td>{c['activityDetailNotes']}</td>
                                      <td>
                                        <div className="trtui-hstack trtui-gap-3 trtui-flex-wrap">
                                          <span
                                            onClick={() => openView(c)}
                                            className="trtui-link-success trtui-fs-15 trtui-cursor-pointer"
                                          >
                                            <i className="ri-eye-line" />
                                          </span>
                                        </div>
                                      </td>
                                    </tr>
                                  ),
                                )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Activities.propTypes = {
  isLocalEnvironment: PropTypes.string,
  childFormData: PropTypes.object,
  setOpenActivity: PropTypes.func,
}
